import React from 'react'
import styled from 'styled-components'
import { breakpoints } from '../../../constants/breakpoits.constants'
import Container from '../../../components/layout/container.component'
import PartnerItem from './partners/partner-item.component'
import imageDefault from './partners/img/no-logo.png'

const StyledContainer = styled.div`
	color: white;
	display: none;
	font-size: 12px;

	font-weight: bold;
	margin-bottom: 15px;

	@media (min-width: ${breakpoints.MOBILE}px) {
		margin-top: 60px;
	}

	.itens {
		text-align: center;
		align-items: center;
		flex-direction: column;
		display: inline-flexbox;
	}
	@media (min-width: ${breakpoints.MOBILE}px) {
		margin-top: 40px;
	}
`

const MoveflexPartnersSection = () => {
	return (
		<Container>
			<div className="hide" style={{ textAlign: 'center', display: 'none' }}>
				<h2 className="blue bold">Parceiros</h2>
			</div>
			<StyledContainer>
				<div className="itens">
					<PartnerItem src={imageDefault} />
					<PartnerItem src={imageDefault} />
					<PartnerItem src={imageDefault} />
					<PartnerItem src={imageDefault} />
				</div>
			</StyledContainer>
		</Container>
	)
}

export default MoveflexPartnersSection
